import React, { FC } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CompletedCardHolder } from '~/img';
import theme from '~/constants/theme';
import WizardContent from '~/layouts/WizardContent';

const Completion: FC = () => {
  const { t } = useTranslation('completion');

  return (
    <WizardContent
      left={<></>}
      content={
        <Container className="Completed">
          <div className="Completed-Content">
            <Typography.Title className="Completed-Title">{t('Thank you!')}</Typography.Title>
            <Typography.Paragraph className="Completed-Paragraph">
              <p>
                {t(
                  'We have received and we are reviewing your application now. We will notify you when we are finished, or if we need further information.',
                )}
              </p>
              {/* <p>{t('cardholder.completion.welcome.label2')}</p> */}
            </Typography.Paragraph>
            <CompletedCardHolder className="Completed-Img" />
          </div>
        </Container>
      }
      right={<></>}
    />
  );
};

const Container = styled.div`
  .Completed-Content {
    position: relative;
    .Completed-Img {
      width: 100%;
      margin-bottom: 24px;
    }
    .Completed-Paragraph {
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .Completed-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
      }
      .Completed-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .Completed-Paragraph {
        margin-left: 0;
      }
    }
  }
  .Completed-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .Completed-ContactUs {
      display: none;
    }
  }
`;

export default Completion;
